import { jsx as _jsx } from "react/jsx-runtime";
import { ISSUES_GROUP } from '../../../constants/api';
import { IS_APP_CODEAC } from '../../../constants/env';
import ClearFilterReport from './ClearFilterReport';
import { ReportDetailItem } from './ReportDetailItem';
const PADDING_LINES_COUNT = 10;
const calculateRemainingLines = (messages) => {
    const remainingLines = {};
    messages.forEach((message) => {
        const startLine = message.line - PADDING_LINES_COUNT >= 0 ? message.line - PADDING_LINES_COUNT : 0;
        const endLine = (message.endLine ? message.endLine : message.line) + PADDING_LINES_COUNT;
        for (let i = startLine; i < endLine; i++) {
            if (typeof remainingLines[i] === 'undefined') {
                remainingLines[i] = [];
            }
        }
        if (typeof remainingLines[message.line - 1] !== 'undefined') {
            remainingLines[message.line - 1].push(message);
        }
    });
    return remainingLines;
};
const filterRowsByHiddenType = (lines, hiddenType) => {
    if (!lines.length) {
        return;
    }
    return lines.filter((line) => hiddenType === ISSUES_GROUP.ERRORS ? line.isError === false : line.isError === true);
};
export const FileReport = (props) => {
    const { file, generated, hiddenType, isRepositoryPrivate, proPlan, coveredLines, copiedFilePath, fileIndex, expandedIssues, browser, showAutoFixesClick, onLoadClick, onFilePath, onToggleIssueDocs, } = props;
    const remainLines = calculateRemainingLines(file.messages);
    const sourceLines = file.source.split(/\r\n|\n|\r/);
    const totalLinesCount = sourceLines.length;
    const blocks = [];
    let blockIndex = 0;
    for (let i = 0; i < totalLinesCount; i++) {
        if (typeof remainLines[i] === 'undefined') {
            if (blockIndex + 1 === blocks.length) {
                blockIndex++;
            }
        }
        else {
            if (blockIndex + 1 > blocks.length) {
                blocks.push({
                    startLine: i,
                    endLine: Math.min(i + PADDING_LINES_COUNT, totalLinesCount),
                    messages: { [i]: hiddenType ? filterRowsByHiddenType(remainLines[i], hiddenType) : remainLines[i] },
                });
            }
            else {
                blocks[blockIndex].endLine =
                    remainLines[i].length > 0 ? Math.min(i + PADDING_LINES_COUNT, totalLinesCount) : i;
                blocks[blockIndex].messages[i] = hiddenType
                    ? filterRowsByHiddenType(remainLines[i], hiddenType)
                    : remainLines[i];
            }
        }
    }
    const showTrialContent = IS_APP_CODEAC && !proPlan && fileIndex !== 1 && isRepositoryPrivate;
    if (showTrialContent) {
        return _jsx("div", { className: "trial-report", children: _jsx(ClearFilterReport, { showTrial: showTrialContent, file: file, generated: generated, errorsLeft: file.errorCount, warningsLeft: file.warningCount }) });
    }
    return _jsx(ReportDetailItem, { file: file, generated: generated, blocks: blocks, sourceLines: sourceLines, fileIndex: fileIndex, copiedFilePath: copiedFilePath, coveredLines: coveredLines, showAutoFixesClick: showAutoFixesClick, onLoadClick: onLoadClick, expandedIssues: expandedIssues, onFilePath: onFilePath, onToggleIssueDocs: onToggleIssueDocs, browser: browser }, file.filePath);
};
